<template>
  <div class="forma-erp teya-postavke">

    <div class="traka-ekrana mb-3">
      <div class="naslov">Teya kartični aparat</div>
      <div class="brojka">
        <span>Firma</span>
        <b>{{ nazivFirme }}</b>
      </div>
      <div class="brojka" v-if="okolina">
        <span>Okolina</span>
        <b>{{ okolina === 'test' ? 'razvojna' : 'produkcija' }}</b>
      </div>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="radim" indeterminate color="primary" size="22" class="mr-3"></v-progress-circular>
      <v-btn small outlined color="primary" class="mr-2" @click="ucitaj">Osvježi</v-btn>
    </div>

    <!-- Bez partnerskih vjerodajnica se ne moze ni zapoceti; bolje to reci
         nego pustiti korisnika da klikce po necemu sto ne radi. -->
    <v-alert v-if="!postavljen" type="warning" dense outlined class="mb-3">
      Na poslužitelju nisu upisane Teya vjerodajnice
      (<code>TEYA_CLIENT_ID</code> i <code>TEYA_CLIENT_SECRET</code>).
      Bez njih se aparat ne može povezati.
    </v-alert>

    <v-alert v-if="greska" type="error" dense outlined class="mb-3">{{ greska }}</v-alert>

    <v-row no-gutters>
      <v-col cols="12" md="6" class="pr-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            Veza s Teyom
            <span class="dodatak">{{ veza && veza.povezana ? 'povezano' : 'nije povezano' }}</span>
          </v-card-title>
          <v-card-text class="tijelo">

            <div v-if="!veza || !veza.povezana">
              <p class="uz">
                Prijavite se svojim Teya računom. Otvorit će se Teyina stranica,
                a nakon prijave se vraćate ovamo.
              </p>
              <v-btn color="primary" class="text-none" :disabled="!postavljen || radim" @click="poveziSe">
                <v-icon small left>mdi-link-variant</v-icon>Poveži s Teyom
              </v-btn>
            </div>

            <div v-else>
              <div class="redak">
                <span>Poslovnica</span>
                <b>{{ veza.storeNaziv || veza.storeId || '—' }}</b>
              </div>
              <div class="redak">
                <span>Aparat</span>
                <b v-if="veza.terminalId">
                  {{ veza.terminalNaziv || veza.terminalId }}
                  <small v-if="veza.terminalSerijski">· {{ veza.terminalSerijski }}</small>
                </b>
                <b v-else class="nedostaje">nije odabran</b>
              </div>
              <div class="redak">
                <span>Povezano</span>
                <b>{{ datum(veza.povezano) }}</b>
              </div>

              <v-btn text small color="red" class="text-none mt-2 pa-0" @click="odspoji">
                <v-icon small left>mdi-link-variant-off</v-icon>Odspoji
              </v-btn>
            </div>

          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="mb-3" v-if="veza && veza.povezana">
          <v-card-title class="naslov-kartice">
            Poslovnica i aparat
            <span class="dodatak">serijski broj piše na aparatu</span>
          </v-card-title>
          <v-card-text class="tijelo">

            <v-select
              outlined dense hide-details="auto" class="mb-3"
              label="Poslovnica"
              :items="poslovnice"
              item-text="naziv"
              item-value="id"
              v-model="odabranaPoslovnica"
              :loading="ucitavamPoslovnice"
              no-data-text="Nema poslovnica"
            ></v-select>

            <v-select
              outlined dense hide-details="auto" class="mb-3"
              label="Kartični aparat"
              :items="aparatiZaIzbor"
              item-text="opis"
              item-value="id"
              v-model="odabraniAparat"
              :loading="ucitavamAparate"
              no-data-text="Poslovnica nema nijedan aparat"
            ></v-select>

            <v-btn color="primary" class="text-none"
              :disabled="!odabranaPoslovnica || !odabraniAparat || radim"
              @click="spremiIzbor">
              <v-icon small left>mdi-content-save</v-icon>Spremi
            </v-btn>
          </v-card-text>
        </v-card>

        <v-card outlined v-if="veza && veza.spremna">
          <v-card-title class="naslov-kartice">Kako se koristi</v-card-title>
          <v-card-text class="tijelo uz">
            Na kasi odaberite <b>Kartica</b> pa <b>Naplati</b>.
            Iznos ide na aparat, a račun se fiskalizira <b>tek kad kartica prođe</b> —
            storna nema, pa se fiskalizirani račun ne bi imao čime poništiti.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="poruka" :timeout="4000" :color="bojaPoruke" bottom>
      {{ tekstPoruke }}
      <v-btn text @click="poruka = false">Zatvori</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import TeyaService from '@/services/TeyaService'
import dayjs from 'dayjs'

export default {
  name: 'teyapostavke',

  data () {
    return {
      radim: false,
      postavljen: false,
      okolina: '',
      veza: null,
      greska: '',
      poslovnice: [],
      aparati: [],
      odabranaPoslovnica: null,
      odabraniAparat: null,
      ucitavamPoslovnice: false,
      ucitavamAparate: false,
      poruka: false,
      tekstPoruke: '',
      bojaPoruke: 'success'
    }
  },

  computed: {
    nazivFirme () {
      return this.$store.state.companyName || ''
    },
    // Serijski broj je jedino sto pise na aparatu, pa ide uz naziv.
    aparatiZaIzbor () {
      return this.aparati.map(a => ({
        id: a.id,
        opis: [a.naziv, a.serijski].filter(x => x).join(' · '),
        naziv: a.naziv,
        serijski: a.serijski
      }))
    }
  },

  watch: {
    odabranaPoslovnica (id) {
      if (id) { this.ucitajAparate(id) }
    }
  },

  mounted () {
    this.ucitaj()
  },

  methods: {
    javi (tekst, boja) {
      this.tekstPoruke = tekst
      this.bojaPoruke = boja || 'success'
      this.poruka = true
    },

    datum (d) {
      return d ? dayjs(d).format('DD.MM.YYYY. HH:mm') : '—'
    },

    upit () {
      return {
        CompanyId: this.$store.state.companyid,
        CompanyNameDatabase: this.$store.state.companyName
      }
    },

    async ucitaj () {
      this.radim = true
      this.greska = ''
      try {
        const {data} = await TeyaService.veza(this.upit())
        this.postavljen = !!data.postavljen
        this.okolina = data.okolina
        this.veza = data.veza
        if (this.veza && this.veza.povezana) {
          this.odabranaPoslovnica = this.veza.storeId || null
          this.odabraniAparat = this.veza.terminalId || null
          await this.ucitajPoslovnice()
        }
      } catch (err) {
        this.greska = this.tekstGreske(err)
      } finally {
        this.radim = false
      }
    },

    async ucitajPoslovnice () {
      this.ucitavamPoslovnice = true
      try {
        const {data} = await TeyaService.poslovnice(this.upit())
        this.poslovnice = data.poslovnice || []
        if (!this.odabranaPoslovnica && this.poslovnice.length === 1) {
          this.odabranaPoslovnica = this.poslovnice[0].id
        }
        if (this.odabranaPoslovnica) { await this.ucitajAparate(this.odabranaPoslovnica) }
      } catch (err) {
        this.greska = this.tekstGreske(err)
      } finally {
        this.ucitavamPoslovnice = false
      }
    },

    async ucitajAparate (storeId) {
      this.ucitavamAparate = true
      try {
        const {data} = await TeyaService.aparati(Object.assign(this.upit(), {storeId}))
        this.aparati = data.aparati || []
        if (!this.odabraniAparat && this.aparati.length === 1) {
          this.odabraniAparat = this.aparati[0].id
        }
      } catch (err) {
        this.greska = this.tekstGreske(err)
      } finally {
        this.ucitavamAparate = false
      }
    },

    // Prijava vodi izvan aplikacije, pa se sjednica gubi - korisnik se nakon
    // povratka mora ponovno prijaviti u Roboot. To je namjerno: Teyin token ne
    // smije nikad doci do preglednika.
    async poveziSe () {
      this.radim = true
      try {
        const {data} = await TeyaService.prijava(this.upit())
        window.location.href = data.url
      } catch (err) {
        this.greska = this.tekstGreske(err)
        this.radim = false
      }
    },

    async spremiIzbor () {
      this.radim = true
      try {
        const p = this.poslovnice.find(x => x.id === this.odabranaPoslovnica)
        const a = this.aparatiZaIzbor.find(x => x.id === this.odabraniAparat)
        const {data} = await TeyaService.odaberi(Object.assign(this.upit(), {
          storeId: this.odabranaPoslovnica,
          storeNaziv: p ? p.naziv : null,
          terminalId: this.odabraniAparat,
          terminalNaziv: a ? a.naziv : null,
          terminalSerijski: a ? a.serijski : null
        }))
        this.veza = data.veza
        this.javi('Aparat je spremljen.')
      } catch (err) {
        this.greska = this.tekstGreske(err)
      } finally {
        this.radim = false
      }
    },

    async odspoji () {
      if (!window.confirm('Odspojiti kasu od Teye? Kartično plaćanje na kasi neće raditi dok se ponovno ne povežete.')) { return }
      this.radim = true
      try {
        await TeyaService.odspoji(this.upit())
        this.veza = null
        this.poslovnice = []
        this.aparati = []
        this.odabranaPoslovnica = null
        this.odabraniAparat = null
        this.javi('Odspojeno.', 'warning')
      } catch (err) {
        this.greska = this.tekstGreske(err)
      } finally {
        this.radim = false
      }
    },

    tekstGreske (err) {
      const t = err && err.response && err.response.data
      if (t && t.message) { return t.message }
      return err && err.message ? err.message : 'Nepoznata greška.'
    }
  }
}
</script>

<style scoped>
/* v-card-title je flex, pa razmak izmedu naslova i oznake nestane - mora se
   zadati marginom, inace pise "Veza s Teyomnije povezano". */
.teya-postavke .naslov-kartice .dodatak {
  font-weight: 400;
  font-size: 12px;
  color: #6b8299;
  margin-left: 8px;
}
.teya-postavke .uz { color: #607d8b; font-size: 13px; }
.teya-postavke .redak {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 5px 0;
  border-bottom: 1px solid #eceff1;
}
.teya-postavke .redak:last-of-type { border-bottom: 0; }
.teya-postavke .redak span { color: #78909c; font-size: 13px; }
.teya-postavke .redak b { color: #263238; }
.teya-postavke .redak small { color: #90a4ae; font-weight: 400; }
.teya-postavke .nedostaje { color: #c62828; font-weight: 600; }
</style>
